import { useState, useContext } from 'react'
import { DataContext, DataDispatchContext } from '../../../contexts/data/dataContext'
import { 
  homeIconDefault,
  homeIconSelected,
  solarIconDefault,
  solarIconSelected,
  batteryIconDefault,
  batteryIconSelected,
  gridIconDefault,
  gridIconSelected,
} from '../../common/iconPaths'
import MobileNavigation from '../../common/mobileNavigation';

export default function ReportMobileNavigation({ clickAnalytics }: any) {
    const dispatch: any = useContext(DataDispatchContext)
    const data: any = useContext(DataContext)
    const [selected, setSelected] = useState(data?.reportSelected);

    const handleMenuClick = (event: any) => {
        const id = `${event.currentTarget.id}`.replace('Mobile','')
        setSelected(id)
        dispatch({
          type: 'setReportSelected',
          selected: id
        })
        clickAnalytics(id)
      }

    const navItemList = [
      {
          id: 'home',
          name: "Home",
          iconPath: homeIconDefault,
          selected: homeIconSelected,
          action: handleMenuClick
      },
      {
          id: 'solar',
          name: "Solar",
          iconPath: solarIconDefault,
          selected: solarIconSelected,
          action: handleMenuClick
      },
      {
          id: 'battery',
          name: "Battery",
          iconPath: batteryIconDefault,
          selected: batteryIconSelected,
          action: handleMenuClick
      },
      {
          id: 'grid',
          name: "Grid",
          iconPath: gridIconDefault,
          selected: gridIconSelected,
          action: handleMenuClick
      }
    ]
    const itemSelected: any = navItemList.find(item=>item.id===selected)


    return (
      <MobileNavigation 
        navItemList={navItemList}
        title={"Performance"}
        itemSelected={itemSelected}
        defaultSelected={data?.reportSelected}
        handleMenuClick={handleMenuClick}
    />
    )
}